export default __webpack_public_path__ + "media/images/btn-add2-7becb825d210db62ba2a1678fe582a5a.png";